import { ReservationUploadedContractFileSignatureStatus } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { lt } from '@mews/framework';

const MEGA_BYTE = 1024 * 1024;
const MAX_FILE_SIZE = 25;
const FILE_SIZE_LIMIT = MAX_FILE_SIZE * MEGA_BYTE;
const FILE_SIZE_LIMIT_TEXT = `${MAX_FILE_SIZE}MB`;
export const SUPPORTED_FILE_EXTENSIONS = '.pdf';

export const FILE_SCHEMA_OPTIONS = {
    sizeLimit: {
        bytes: FILE_SIZE_LIMIT,
        text: FILE_SIZE_LIMIT_TEXT,
        perFile: true,
    },
    acceptedTypes: ['application/pdf'],
    allowMultiple: false,
};

export const SIGNATURE_STATUS_OPTIONS = [
    createOption({
        value: ReservationUploadedContractFileSignatureStatus.Signed,
        label: lt('ContractSignatureStatusSignedLabel'),
    }),
    createOption({
        value: ReservationUploadedContractFileSignatureStatus.Pending,
        label: lt('ContractSignatureStatusPendingLabel'),
    }),
];
